export default {
  custom: {
    batchModify: '批量修改',
    importResumeanalysis: '導入簡歷解析',
    exportList: '導出列表',
    exportAllFields: '導出全部字段',
    webfromlink: 'WEB表單鏈接',
    transfer: '轉移',
    receive: '領取',
    distribution: '分配',
    move: '移動',
    modify: '修改',
    returnToHighSeas: '退回公海池',
    returnToHighSeasSuccess: '已退回公海池',
    receiveSuccess: '領取成功',
    share: '共享',
    nextStep: '下壹步',
    linkPublish: '鏈接發布',
    technicalSupport: '數字一體化管理平台',
    dataDetails: '數據詳情',
    basicData: '基本資料',
    open: '打開',
    copy: '復制',
    openAccess: '公開訪問',
    accessWithPwd: '憑密碼訪問',
    scanQRcodeForFriend: '掃二維碼，分享給好友',
    SigninQRcode: '簽到二維碼',
    downloadQRcode: '下載二維碼',
    extendedLinks: '擴展鏈接',
    multipleLinkMsg: '對同壹個表單賦予多個鏈接地址，用於標識不同數據提交來源',
    copyToClipboard: '已復制至剪切板',
    signin: '簽到',
    addSubmenu: '添加子菜單',
    checkShowFields: '勾選您要顯示的字段',
    batchupdateMsg1: '數據批量修改後將不允許撤回，不支持對查重字段、選項字段控制-控制字段批量修改;',
    batchupdateMsg2:
      '不支持批量修改組件包含：附件、圖片、簡單公式、函數公式、高級公式、自動編號、關聯關系、條碼、定位、富文本;',
    fieldsToModify: '要修改的字段',
    modifiedValue: '修改的值為',
    modifiedValueNotEmpty: '修改的值不能為空',
    emailFormatError: '電子郵箱格式錯誤',
    phoneFormatError: '手機格式錯誤',
    enterInteget: '請輸入整數',
    numComponentMaxlength9: '數字組件最大長度為9位數',
    decimalNumber: '小數位最多為',
    batchupdataSuccess: '批量修改完成',
    batchupdataLongMsg: '處理時間過長,您可以先去處理其他工作，系統會繼續處理剩余數據.',
    selectMatchingRule: '請選擇匹配規則',
    diyNeeds: '個性化需求',
    writeLetters: '寫信',
    dynamic: '動態',
    transferPerson: '轉移負責人',
    transformation: '轉換',
    dataLink: '數據鏈接',
    matching: '匹配',
    datalinkNotopen: '未開啟數據鏈接',
    automationTuijian: '自動化推薦',
    uploadPictures: '上傳圖片',
    addAttachments: '添加附件',
    useAppScan: '使用平台移動端掃描訪問數據',
    noPermission: '無權進行此操作',
    name: '名稱',
    screenConditions: '篩選條件',
    visibleMembers: '可見成員',
    submenuNameRequired: '子菜單名稱必填',
    hideOlderDynamics: '隱藏較早動態',
    haveChecked: '已查看',
    noLook: '未查看',
    operator: '操作人',
    operationTime: '操作時間',
    comment: '溝通',
    lookState: '查看狀態',
    unknownNameData: '未知名稱的數據',
    batchImportResumeanalysis: '批量導入簡歷解析',
    selectResumeFile: '請選擇需要導入的簡歷文件',
    clickUploadMulitpResumeFile: '點擊可上傳多份簡歷，每次最多上傳10個,單個文件不得超過10MB',
    addFile: '添加文件',
    supportDoc: '支持doc、docx、pdf、html、JPG、BMP等格式',
    analyticalResults: '解析結果',
    analyticalComplete: '解析成功',
    analyticalFail: '解析失敗,請檢查網路是否正常',
    dataOutLink: '數據外鏈',
    dataInLink: '數據內鏈',
    onlyUseAppSaoyisao: '僅支持使用平台移動端掃壹掃訪問數據',
    dataSharingSettings: '指定的數據共享設置,可將部門或成員壹起共享此數據',
    shareTo: '共享給',
    accessAuth: '訪問權限',
    onlyReady: '只讀',
    readyEdit: '讀寫',
    readyEditDelete: '讀寫刪',
    modulePrintPdf: '模塊詳情頁面打印（PDF格式）',
    printPreview: '打印預覽',
    printSetting: '打印設置',
    downloadTemplate: '下載模版',
    importTemplate: '導入模版',
    complete: '完成',
    importData: '導入數據',
    updateData: '更新簽到狀態',
    pleaseImportData: '請按照數據模版的格式準備要導入的數據',
    mattersNeedingAttention: '註意事項',
    updateDataBeCareful1: '導入模板可自行進行創建，導入模板必須為xls格式',
    updateDataBeCareful2: '模板第壹行為列表字段，需包含匹配字段名稱和簽到狀態；名稱必須壹致',
    updateDataBeCareful3:
      '匹配字段最好選擇無重復數據的字段，若導入更新時匹配到多條數據，以最新的數據作為更新內容',
    updateDataBeCareful4: '更新導入只能對已有數據進行更改',
    importDataBeCareful1: '模版中的表頭名稱不可更改，表頭行不能刪除',
    importDataBeCareful2: '導入格式為xlsx，最多只允許上傳10000條，文件大小不超過20M',
    importDataBeCareful3:
      '單選類型：系統提供字段對應的單選值，用戶只能選擇，不能手動輸入，否則會報錯',
    importDataBeCareful4:
      '多選類型：字段備註提供該字段對應的選項值，用戶需自行輸入選項值，如果有多個選項值請使用英文","隔開',
    importDataBeCareful5: '日期/時間格式要求：2018-2-23、2018-8-23 12:00:00',
    importDataBeCareful6: '多級下拉：用戶需自行輸入多級下拉選項值，選項值用英文","隔開',
    importDataBeCareful7: '子表單：新sheet頁面中顯示子表單內容，通過子表單編號對應主表序號形成對應',
    clickDownloadTemplate: '點此下載數據導入模版',
    chooseTemplate: '選擇需要導入的數據模版',
    dataTemplateMax10000:
      '數據模版中，表頭字段名稱需與系統保持壹致，單次導入行數不得超過10000行，超出請分批導入',
    chooseMatchingData: '選擇匹配數據後要更新的字段',
    chooseDataField: '選擇數據的匹配字段',
    addComplete: '添加成功',
    importError1: '導入數據失敗，請下載失敗日誌',
    importError2: '點此下載導入失敗日誌',
    importError3: '導入數據失敗',
    chooseMatchField: '請選擇數據的匹配字段',
    chooseUpdateloadTemplate: '請上傳模版文件',
    startImport: '開始導入',
    return: '退回',
    moveTo: '移動至',
    moveComplete: '移動成功',
    closeAll: '關閉全部',
    closeOther: '關閉其他',
    refreshCurrentPage: '刷新當前頁',
    Correlation: '關聯關系',
    serialNumber: '序號',
    autoCreate: '自動生成',
    checkRepeat: '查重',
    checkInStatus: '簽到狀態',
    selectProvince: '選擇省市區',
    unknown: '未知',
    saveAutoCreate: '保存後自動生成',
    saveAutoCompute: '保存後自動計算',
    national: '全國',
    uploadResume: '上傳簡歷',
    oneFileMax10M: '單個文件不得超過10MB',
    supportDocDocx: '支持doc、docx、pdf、html、JPG、BMP等格式',
    analysisFailCheckNetwork: '解析失敗，請檢查網絡是否正常',
    addRecords: '添加記錄',
    uploadAvatar: '上傳頭像',
    gray: '灰度',
    blackWhite: '黑白',
    inverse: '反色',
    attPicNotFirst: '附件和圖片不要放在第壹位',
    subformNotFirst: '子表單不能放在第壹位',
    zhangsan: '張三',
    proviewMode: '預覽模式',
    transTargetModule: '可轉換目標模塊',
    noTransModule: '無轉換模塊',
    transSuccess: '轉換成功',
    ifTransDataInfo: '將當前數據的負責人轉移給其他負責人? 轉移成功後，該操作將無法恢復',
    transShareMember: '轉移後共享給當前數據負責人',
    personNotEmpty: '負責人不能為空',
    sharepersonNotEmpty: '共享人不能為空',
    fenpeiSuccess: '分配成功',
    selectReturnHighpool: '選擇要退回的公海池',
    selectMoveHighpool: '選擇要移動至的公海池',
    personnelCard: '個人名片',

    // 2020-10-15
    editModuleLayout: '模塊設置',
    modifyIconName: '修改圖標和名稱',
    manageCockpit: '數據報表',
    total: '總計',
    determineDelReport: '確定要刪除該數據分析嗎?',
    realNameAuthMsg: '實名認證時 姓名/身份證號 不能為空',
    idCardBad: '身份證號格式不正確',
    verificationPassed: '校驗通過',
    verificationFailed: '校驗不通過',
    continueSaving: '繼續保存',
    doNotSave: '不保存',
    sendEmail: '發送郵件',
    record: '條記錄',
    showNotFilledField: '顯示未填字段',
    hiddenNotFilledField: '隱藏未填字段',
    idCradPicture1: '人像面照片',
    idCradPicture2: '國徽面照片',
    // 新增：行驶证上传说明
    idCradPicture3: '行駛證圖片',
    freezeThisColumn: '凍結此列',
    unfreezeThisColumn: '解凍此列',
    uploadOnly: '只允許上傳',
    limitPerPicture: '每張圖片限制',
    limitPerAttachment: '每個附件限制',
    manageSubmenu: '管理子菜單',
    hierarchyView: '層級視圖',
    timeAxisView: '時間軸視圖',
    moduleSubmenuInfo1: '可拖動調整子菜單的顯示位置',
    moduleSubmenuInfo2:
      '選擇壹個選項類型的字段，數據將按照此字段中的選項值分組顯示在看板中。支持組件：下拉選項（單選）、復選框（單選）',
    moduleSubmenuInfo3:
      '選擇壹個關聯關系的字段，數據將按照此字段中的父子級從左往右按樹形狀進行層級顯示。支持組件：關聯關系（關聯自己模塊，如客戶模塊關聯客戶模塊）',
    moduleSubmenuInfo4: '數據內容以添加的時間順序展示',
    viewName: '視圖名稱',
    timelineField: '時間軸字段',
    sortOrder: '排序方式',
    selectGroupField: '選擇分組字段',
    formNotEligibleField: '當前表單中沒有符合條件的字段',
    fieldsGroup: '字段分組',
    cardAppearance: '卡片外觀',
    moreAdd8Field: '限制添加8個字段',
    showFieldName: '顯示字段名稱',
    showField: '顯示字段',
    pleaseSelectGroupField: '請選擇分組字段',
    onlyOneSelectField: '請至少選擇壹個顯示字段',
    startString: '起始字符',
    kanban: '看板',
    hierarchy: '層級',
    timeLine: '時間軸',
    allDynamic: '所有動態',
    onlyDynamic: '僅評論',
    onlyViewStatus: '僅查看狀態',
    onlyOperationLog: '僅操作日誌',
    showOlder: '顯示較早的',
    groupFieldDel: '分組字段被刪除，請編輯該子菜單',
    notSpecified: '未指定',
    adaptToScreen: '適應屏幕',
    unknownTime: '未知時間',
    addDataToSeas: '通過該鏈接可自動將數據建立到公海池中且標識不同數據提交來源',
    cashier: '收銀臺',
    paymentCompleted: '支付完成',
    choosePaymentMethod: '選擇支付方式',
    successfulCollection: '收款成功',
    paymentByCanning: '掃壹掃付款（元）',
    openMobileWechat: '打開手機微信',
    openMobileAlipay: '打開手機支付寶',
    scanToCompletePayment: '掃壹掃完成支付',
    manageApplication: '應用管理',
    applicationDescription: '應用說明',
    enterpriseInfo: '企業信息',
    riskInfo: '風險信息',
    transferOtherrelatedModules: '轉移其它相關模塊',
    uploadMore10Files: '每次最多上傳10個文件',
    onlyNewCreate: '僅新建',
    companyInfo1: '友情提示：請輸入正確的名稱',
    companyInfo2: '正在查詢中',
    companyInfo3: '法人',
    companyInfo4: '經營狀態',
    notSetAppInfo: '未設置應用說明',
    paid: '已付款',
    toBePaid: '待付款',
    orderPayment: '訂單支付',
    autoCount: '自動計算',
    payCallbackInfo: '金額>0 時可點擊進行收款',
    detailData: '詳情資料',

    // 2020-12-25国际化
    shareOtherModule: '共享其它相關模塊',
    subformBatchupdateMsg1: '對子表單的數據進行批量修改，不支持對查重字段批量修改',
    subformBatchupdateMsg2:
      '附件、圖片、簡單公式、函數公式、高級公式、引用公式、自動編號、流水號、條碼、手寫簽名、簡歷解析',
    CopyLine: '復制行',
    OnlineConsulting: '在線咨詢',
    NameFfTrialCompany: '試機構名稱',

    // 2021-04-12
    selectOneColumn: '請至少選擇一個字段作為導出列',
    selectExportFields: '選擇需要導出的字段（勾選代表導出該字段值）',
    companyDataKanban: '機構營銷數據看板',
    personalDataKanban: '個人營銷數據看板',
    visitorsToAnalysis: '訪客分析',
    newAddSevendays: '近七日新增訪問',
    accessTotalNum: '訪問總數',
    NewDayAdd: '日新增',
    shareTotalNum: '分享總數',
    accessData: '訪問數據',
    AllTotal: '累計總量',
    yesterday: '昨日',
    nearly7days: '近7天',
    nearly30days: '近30天',
    visitorsInterested: '訪客興趣',
    visitorActivity: '訪客活躍度',
    VisitorProduct: '訪客產品互動',
    AccessToheTotal: '訪問總量',
    BusinessCardLook: '名片查看',
    BusinessCardShare: '名片分享',
    BusinessCardCollection: '名片收藏',
    productLook: '產品查看',
    productShare: '產品分享',
    product: '產品',
    videos: '視頻',
    shareBusinessCard: '分享名片',
    AccessToInterest: '訪問興趣',
    AccessToSource: '訪問來源',
    InteractiveRecord: '互動記錄',
    AIAnalysis: 'AI分析',
    allTheRecords: '所有記錄',
    transToBussData: '轉為業務數據',
    sureTransBussData: '確定要轉為業務數據嗎?',
    batchDownload: '全部下載',

    // 2022-04-12
    InsertRowsAbove: '在上方插入行',
    InsertRowsBelow: '在下方插入行',
    DataSharingSettings: '數據共享設置',
    MapMode: '地圖式',
    selectPagesExportNum: '請選擇導出的分頁數量',
    amount: '數量',
    relatedContent: '關聯內容',
    searchModule: '搜索模塊',
    largeAmountData: '數據量過大',
    largeAmountDataInfo: '請在列字段中「篩選」數據，篩選後顯示列表數據'
  }
}
